import { accreditation } from '@store/modules/accreditation';
import { RouteConfig } from 'vue-router';

/* eslint-disable @typescript-eslint/explicit-function-return-type */
const accreditationRoutes: RouteConfig = {
	path: `/account/accreditation/verify`,
	name: 'accreditation',
	component: () =>
		import(/* webpackChunkName: "accreditation" */ '@views/accreditation/accreditation-verify-start.vue'),
	redirect: { name: 'accreditation-verification-methods' },
	children: [
		{
			path: `method`,
			name: 'accreditation-verification-methods',
			meta: { step: 1 },
			component: () =>
				import(
					/* webpackChunkName: "accreditation-verification-methods" */ '@views/accreditation/accreditation-verification-methods.vue'
				)
		},
		{
			path: `type`,
			name: 'accreditation-document-type',
			meta: { step: 2 },
			component: () =>
				import(
					/* webpackChunkName: "accreditation-document-type" */ '@views/accreditation/accreditation-document-type.vue'
				)
		},
		{
			path: `upload`,
			name: 'accreditation-document-upload',
			meta: { step: 3 },
			beforeEnter: async (to, from, next) => {
				if (accreditation.verificationType === null) {
					next({ name: 'verification-type' });
				} else {
					next();
				}
			},
			component: () =>
				import(
					/* webpackChunkName: "accreditation-document-upload" */ '@views/accreditation/accreditation-document-upload.vue'
				)
		},
		{
			path: `success`,
			name: 'accreditation-upload-success',
			meta: { step: 4 },
			component: () =>
				import(
					/* webpackChunkName: "accreditation-upload-success" */ '@views/accreditation/accreditation-upload-success.vue'
				)
		}
	]
};

export default accreditationRoutes;
